import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getActiveUser} from '../../../apis/analysis/getMau'
import {getRegiserUser} from '../../../apis/analysis/getRegisterUser'

export const useQueryRegisterUser = (limit: number) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.analysis.getRegisterUser(limit),
        queryFn: async () => {
            const {data} = await getRegiserUser(limit)
            return data
        },
    })

    return {data, refetch}
}
